// Auto-generated normalizer for table: CuestionariosIntentos
export function cuestionariosIntentosNormalize(row) {
  return {
    idIntento: row.idIntento ?? row.IdIntento ?? row['IdIntento'] ?? 0,
    idCuestionario: row.idCuestionario ?? row.IdCuestionario ?? row['IdCuestionario'] ?? 0,
    idEstudiante: row.idEstudiante ?? row.IdEstudiante ?? row['IdEstudiante'] ?? 0,
    fechaIntento: row.fechaIntento ?? row.FechaIntento ?? row['FechaIntento'] ?? null,
    resultado: row.resultado ?? row.Resultado ?? row['Resultado'] ?? '',
    calificacion: row.calificacion ?? row.Calificacion ?? row['Calificacion'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
